/**
 * 请求队列管理器
 * 用于控制并发请求数量，避免同时发起大量请求
 */

class RequestQueue {
    constructor(maxConcurrent = 3) {
        this.maxConcurrent = maxConcurrent; // 最大并发数
        this.currentRunning = 0; // 当前运行的请求数
        this.queue = []; // 等待队列
    }

    /**
     * 添加请求到队列
     * @param {Function} requestFn - 返回Promise的请求函数
     * @returns {Promise} 请求结果
     */
    add(requestFn) {
        return new Promise((resolve, reject) => {
            this.queue.push({
                requestFn,
                resolve,
                reject
            });
            console.log(`📋 请求加入队列，当前状态:`, this.getStatus());
            this.process();
        });
    }

    /**
     * 处理队列
     */
    async process() {
        // 如果已达到最大并发数，或队列为空，则不处理
        if (this.currentRunning >= this.maxConcurrent || this.queue.length === 0) {
            if (this.currentRunning >= this.maxConcurrent) {
                console.log(`⏸️ 已达到最大并发数(${this.maxConcurrent})，等待中...`);
            }
            return;
        }

        // 从队列中取出一个请求
        const { requestFn, resolve, reject } = this.queue.shift();
        this.currentRunning++;
        console.log(`🚀 开始执行请求，当前状态:`, this.getStatus());

        try {
            const result = await requestFn();
            resolve(result);
            console.log(`✅ 请求完成，当前状态:`, this.getStatus());
        } catch (error) {
            reject(error);
            console.log(`❌ 请求失败，当前状态:`, this.getStatus());
        } finally {
            this.currentRunning--;
            // 继续处理下一个请求
            this.process();
        }
    }

    /**
     * 清空队列
     */
    clear() {
        this.queue = [];
        this.currentRunning = 0;
    }

    /**
     * 获取队列状态
     */
    getStatus() {
        return {
            waiting: this.queue.length,
            running: this.currentRunning,
            maxConcurrent: this.maxConcurrent
        };
    }
}

// 创建全局K线请求队列（最大并发3个）
export const klineRequestQueue = new RequestQueue(3);

// 导出到全局，方便调试
if (typeof window !== 'undefined') {
    window.klineRequestQueue = klineRequestQueue;
}

export default RequestQueue;
